import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { Location, LocationStrategy } from '@angular/common';

@Component({
  selector: 'app-quiz-list-modal',
  templateUrl: './quiz-list-modal.component.html',
  styleUrls: ['./quiz-list-modal.component.scss']
})
export class QuizListModalComponent implements OnInit {
  noDataMsg: any = {
    title: "No Quiz Found!",
    data: "No quiz added in this session."
  }
  tooltip: string;
  constructor(public dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any,
    private location: Location, private locationStrategy: LocationStrategy, public router: Router, public activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    console.log("DATA IN MODEL", this.data);
    // this.data = [{ _id: '12345678', quizName: 'ABC' }, { _id: '12345678', quizName: 'ABC' }, { _id: '12345678', quizName: 'ABC' }, { _id: '12345678', quizName: 'ABC' }]
  }

  redirect(data) {
    // this.location.replaceState(
    //   this.router.createUrlTree(
    //     [this.locationStrategy.path().split('?')[0]], // Get uri
    //     { relativeTo: '/appear-quiz', queryParams: { quizId: data._id, learnerId: this.data.learnerId }, queryParamsHandling: 'merge' }).toString()
    // );
    // this.location.go(
    this.router.navigate(['/appear-quiz'], { queryParams: { quizId: data._id, learnerId: this.data.learnerId } })
    // )
    // this.router.navigate(['/appear-quiz'], { queryParams: { quizId: data._id, learnerId: this.data.learnerId }, queryParamsHandling:"merge" })
    this.dialogRef.close(null)
  }

  getStatusClass(item) {
    if (item.status) {
      switch (item.status) {
        case 'Submitted':
          this.tooltip = 'Submitted';
          return 'submitted'
          break;

        case 'Completed':
          this.tooltip = 'Completed';
          return 'completed'
          break;

        case 'Requested for Resubmission':
          this.tooltip = 'Request for Resubmission';
          return 'requested'
          break;

        case 'Re-Submitted':
          this.tooltip = 'Re-Submitted';
          return 'resubmitted'
          break;

        case 'Saved':
          this.tooltip = 'Saved';
          return 'saved'
          break;

        default:
          this.tooltip = 'Pending';
          return 'pending'
          break;
      }
    } else {
      this.tooltip = 'Pending';
      return 'pending'
    }
  }

  closeModel() {
    this.dialogRef.close()
  }



  getMoreData() {
    let obj = {
      displayTab: true
    }
    this.dialogRef.close(obj)
  }
}
